import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  Typography,
} from "@mui/material";
import PrimaryButton from "../../common/primaryButton";
import { useDispatch, useSelector } from "react-redux";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import {
  DecryptObjectFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import examActions from "../../Redux/exam/actions";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BsArrowsFullscreen } from "react-icons/bs";
import SecondaryButton from "../../common/secondaryButton";
import Cookies from "js-cookie";
import commonActions from "../../Redux/common/actions";
import feedbackActions from "../../Redux/feedback/actions";
import FeedbackCompletedModal from "./feedbackCompletedModal";
import ZoomModal from "../liveTest/zoomModal";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";

export default function Index() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { questionsAndOptionsFeedback } = useSelector(
    (state) => state.feedbackReducer
  );
  const { heartBeat, projectDetails, instructions } = useSelector(
    (state) => state.examReducer
  );

  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [decryptedParams, setDecryptedParams] = useState({});
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedLanguage, setSelectedlanguage] = useState(null);
  const [value, setValue] = useState(1);
  const [loading, setLoading] = useState(true);

  const encryptedParams = searchParams.get("qNo");
  const imageSize = "L";
  const validLanguages = ["english", "hindi"];
  const language = validLanguages.includes(decryptedParams?.lang)
    ? decryptedParams?.lang
    : selectedLanguage || "english";
  const currentSrNo = decryptedParams?.SrNo;
  const selectedAnswer = decryptedParams?.selectedAnswer;

  const questionLength = questionsAndOptionsFeedback?.questionsList
    ? Object.keys(questionsAndOptionsFeedback.questionsList).length
    : 0;

  const handleSelectedValue = (value) => {
    setSelectedValue(value);
  };

  const handleZoom = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: null, method: "Z", data: null },
    });
  };

  const handleNext = async (action, response) => {
    const formData = {
      imageSize: `${imageSize}`,
      action: `${action}`,
      currentSrNo: questionsAndOptionsFeedback?.questionData?.srNo,
      nextSrNo:
        response === "clearresponse" && action === "next"
          ? questionsAndOptionsFeedback?.questionData?.srNo
          : response === "previous" && action === "next"
          ? questionsAndOptionsFeedback?.questionData?.srNo - 1
          : questionLength === currentSrNo && action === "next"
          ? questionsAndOptionsFeedback?.questionData?.srNo
          : questionsAndOptionsFeedback?.questionData?.srNo + 1,
      selectedAnswer:
        response === "clearresponse" && action === "next"
          ? 0
          : parseInt(selectedValue) ||
            questionsAndOptionsFeedback?.questionData?.selectedAnswer,
      language: `${language}`,
    };

    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: formData?.nextSrNo,
      lang: `${formData?.language}`,
      img: `${formData?.imageSize}`,
    };
    dispatch({
      type: feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
        handleSelectedValue: handleSelectedValue,
      },
    });
  };
  const handleAuditLogFeedback = (selectedValue, action) => {
    const data = {
      srNo: currentSrNo,
      auditLog: [
        {
          selectedValue: questionsAndOptionsFeedback?.questionData
            ?.selectedAnswer
            ? questionsAndOptionsFeedback?.questionData?.selectedAnswer
            : selectedValue,
          Timestamp: `${heartBeat?.data}`,
          studentId: candidateTokenDetails?.user?.id,
          action: `${action}`,
        },
      ],
    };
    dispatch({
      type: feedbackActions.AUDIT_LOG_FEEDBACK,
      payload: { data: data },
    });
  };

  const handleChange = async (e) => {
    const formData = {
      imageSize: `${imageSize}`,
      action: `next`,
      currentSrNo:
        currentSrNo || questionsAndOptionsFeedback?.questionData?.srNo,
      nextSrNo: currentSrNo || questionsAndOptionsFeedback?.questionData?.srNo,
      selectedAnswer:
        parseInt(e.target.value) ||
        questionsAndOptionsFeedback?.questionData?.selectedAnswer,
      language: `${language}`,
    };

    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: currentSrNo || questionsAndOptionsFeedback?.questionData?.srNo,
      lang: `${language}`,
      img: `${imageSize}`,
    };
    dispatch({
      type: feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
        handleSelectedValue: handleSelectedValue,
      },
    });
    setSelectedValue(e.target.value);
    handleAuditLogFeedback(
      e.target.value,
      'next'
    );
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  useEffect(() => {
    if (encryptedParams) {
      let decrypted = DecryptObjectFunction(encryptedParams);
      setDecryptedParams(decrypted);
    } else {
      navigate(`/${Cookies.get("test_engine_project")}/home`);
    }
  }, [
    encryptedParams,
    questionsAndOptionsFeedback?.questionData?.selectedAnswer,
  ]);

  useEffect(() => {
    if (questionsAndOptionsFeedback?.questionData?.selectedAnswer) {
      setSelectedValue(
        questionsAndOptionsFeedback?.questionData?.selectedAnswer
      );
    }
  }, [decryptedParams]);

  useEffect(() => {
    if (decryptedParams) {
      async function fetchData() {
        if (
          decryptedParams &&
          currentSrNo &&
          !questionsAndOptionsFeedback?.questionData?.srNo
        ) {
          let encodedData, queryParams, encryptedParans;
          queryParams = {
            SrNo: currentSrNo,
            lang: language,
            img: imageSize,
          };
          let formData = {
            imageSize: `${imageSize}`,
            action: "next",
            currentSrNo: currentSrNo,
            nextSrNo: currentSrNo,
            selectedAnswer: selectedAnswer,
            language: `${language}`,
          };

          encodedData = await handleEncodeJson({ encodeJSON: formData });
          dispatch({
            type: feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER,
            payload: {
              data: encodedData,
              navigate: navigate,
              queryParams: queryParams,
            },
          });
        }
      }
      fetchData();
    }
  }, [
    currentSrNo,
    language,
    imageSize,
    selectedAnswer,
    questionsAndOptionsFeedback?.questionData?.srNo,
    decryptedParams,
  ]);
  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
      },
    });
  }, []);

  const handleSubmit = () => {
    Cookies.remove("test_engine_token");
    sessionStorage.removeItem("candidate_exam_details");
    sessionStorage.removeItem("examEnded");
    sessionStorage.removeItem("visitedQuestions");
    sessionStorage.removeItem("cachedQuestionImage");
    sessionStorage.removeItem("candidate_details");
    localStorage.removeItem("updatedQuestionsList");
    localStorage.removeItem("activeSection");
    localStorage.removeItem("examStartTime");
    localStorage.removeItem("examEndTime");
    localStorage.removeItem("remainingTime");
    sessionStorage.removeItem("cachedQuestionImage");
    sessionStorage.removeItem("lastUpdatedIndex");
    sessionStorage.removeItem("remainingTime");
    sessionStorage.removeItem("isEarlyMovedSection");
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: `User selected Submit Button in Feedback`,
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    dispatch({ type: examActions.END_EXAM });
    navigate(`/${Cookies.get("test_engine_project")}/login`);
  };

  const handleLanguageChange = async (language, newValue) => {
    setValue(newValue);
    setSelectedlanguage(language);
    auditLog({
      data: { feedbackLanguageChanged: true, language },
      dispatch,
      heartBeat,
    });
    let encodedData, queryParams, encryptedParans;
    queryParams = {
      SrNo: currentSrNo,
      lang: language,
      img: imageSize,
    };
    let formData = {
      imageSize: `${"L"}`,
      action: "next",
      currentSrNo: currentSrNo,
      nextSrNo: currentSrNo,
      selectedAnswer:
        questionsAndOptionsFeedback?.questionData?.selectedAnswer ||
        selectedAnswer,
      language: `${language}`,
    };
    encodedData = await handleEncodeJson({ encodeJSON: formData });
    encryptedParans = EncryptObjectFunction(queryParams);
    dispatch({
      type: feedbackActions.GET_FEEDBACK_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        navigate: navigate,
        queryParams: queryParams,
      },
    });
  };

  useEffect(() => {
    dispatch({ type: examActions.GET_INSTRUCTIONS });
  }, []);

  useEffect(() => {
    if (instructions?.instructions && instructions?.instructions[0]?.language)
      setSelectedlanguage("english" || instructions?.instructions[0]?.language);
  }, [instructions?.instructions]);

  return (
    <>
      <Grid container sx={{ backgroundColor: "#fff", minHeight: "88vh" }}>
        <Grid item md={2.5} p={2} sx={{ position: "relative" }}>
          <Grid
            p={1}
            sx={{ position: "absolute", bottom: 0, width: "100%" }}
            pb={2}
          >
            <PrimaryButton
              width="89%"
              color="#000"
              borderRadius="138px"
              height="38px"
              onClick={() => {
                handleAuditLogFeedback("", "submit");
                handleSubmit();
              }}
            >
              Submit
            </PrimaryButton>
          </Grid>
        </Grid>
        <Grid
          item
          md={9.4}
          sx={{ background: "rgba(240, 240, 251, 1)", borderRadius: "16px" }}
          p={2}
          mb={2}
          mt={2}
        >
          <Grid container>
            <Grid item md={8}></Grid>
            <Grid
              item
              md={4}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                justifyContent: "flex-end",
              }}
            >
              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  cursor: "pointer",
                }}
                // onClick={handleInstruction}
              >
                <InfoIcon
                  sx={{
                    height: "20px",
                    width: "auto",
                    margin: 0,
                    padding: 0,
                  }}
                />
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                  Instruction
                </Typography>
              </Box> */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>
                  Language
                </Typography>
                <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    onChange={(event) =>
                      handleLanguageChange(event.target.value, 0)
                    }
                    sx={{ height: "30px", width: "140px" }}
                    value={selectedLanguage}
                  >
                    {candidateTokenDetails?.configuration?.languages?.map(
                      (language, index) => (
                        <MenuItem
                          sx={{ textTransform: "capitalize" }}
                          key={index}
                          value={language}
                        >
                          {language?.charAt(0).toUpperCase() +
                            language?.slice(1)}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
          <Grid
            sx={{ display: "flex", justifyContent: "space-between" }}
            pb={1}
            pt={1}
          >
            <Box>
              <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
                Question {questionsAndOptionsFeedback?.questionData?.srNo} of{" "}
                {questionLength}:
              </Typography>
            </Box>
            {/* <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <GoPaperclip style={{ height: "22px", width: "auto" }} />
              <Box
                component={"img"}
                src={logImage}
                alt="img"
                style={{ height: "22px", width: "auto" }}
              />
              <CalculatorComponent />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Typography sx={{ fontSize: "14px", pt: 0.5 }}>Zoom</Typography>
                <FormControl fullWidth size="small">
                  <InputLabel></InputLabel>
                  <Select
                    size="small"
                    label=""
                    sx={{ height: "30px", width: "100px" }}
                    defaultValue={100}
                    // value={zoomLevel}
                    // onChange={handleZoomChange}
                  >
                    <MenuItem value={100}>100%</MenuItem>
                    <MenuItem value={200}>200%</MenuItem>
                    <MenuItem value={400}>300%</MenuItem>
                    <MenuItem value={500}>400%</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Box> */}
          </Grid>
          <Box
            p={1}
            sx={{
              minHeight: "63vh",
              backgroundColor: "white",
              border: "1px solid #E0E0E0",
              borderRadius: "8px",
            }}
          >
            <Grid
              sx={{
                height: "200px",
                paddingRight: "8px",
                border: "1px solid black",
                borderRadius: "8px",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#e0e0e0",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "blue",
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  height: "10px",
                  paddingBottom: "12px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "darkblue",
                },
              }}
            >
              <Grid
                container
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Grid item md={11}>
                  <Box
                    component={"img"}
                    src={questionsAndOptionsFeedback?.questionData?.question}
                    alt={"question"}
                    style={{
                      width: "90%",
                      height: "auto",
                      transition: "width 0.3s ease",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  md={1}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                  p={1}
                >
                  <BsArrowsFullscreen
                    size={20}
                    style={{ cursor: "pointer" }}
                    onClick={handleZoom}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Box pt={1}>
              <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
                Answer
              </Typography>
            </Box>
            <Box
              sx={{
                minHeight: "200px",
                maxHeight: "235px",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#e0e0e0",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "blue",
                  borderRadius: "10px",
                  border: "2px solid #e0e0e0",
                  height: "10px",
                  paddingBottom: "12px",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "darkblue",
                },
              }}
            >
              {questionsAndOptionsFeedback?.questionData?.options?.map(
                (q, i) => (
                  <>
                    <Box
                      style={{ display: "flex", alignItems: "center" }}
                      key={i}
                    >
                      <Radio
                        checked={String(selectedValue) === String(i + 1)}
                        onChange={(e) => handleChange(e)}
                        value={String(i + 1)}
                        name="questionOptions"
                        // onClick={() => handleAuditLogFeedback(i + 1)}
                      />
                      <img
                        src={q}
                        style={{ height: "auto", width: "90%" }}
                        alt={`option-${i}`}
                      />
                    </Box>
                    <Divider sx={{ mr: 4, p: "2px" }} />
                  </>
                )
              )}
            </Box>
          </Box>
          <Grid
            mt={1.3}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box sx={{ display: "flex", gap: "4px" }}>
              {/* <FormControlLabel
                sx={{ margin: 0, padding: 0, color: "rgba(63, 65, 209, 1)" }}
                control={
                  <Checkbox
                    color="success"
                    sx={{
                      margin: 0,
                      padding: 0,
                      color: "rgba(63, 65, 209, 1)",
                    }}
                    onChange={() => {
                      handleAuditLog("", "mark");
                      handleNext("mark");
                    }}
                    checked={markedValue}
                    disabled={timeUp}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "rgba(63, 65, 209, 1)",
                      pt: 0.5,
                    }}
                  >
                    Mark Review
                  </Typography>
                }
              /> */}
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("next", "previous");
                  handleAuditLogFeedback("", "previous");
                }}
                disabled={currentSrNo === 1}
              >
                Previous
              </SecondaryButton>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("next", "clearresponse");
                  handleAuditLogFeedback("", "clear response");
                }}
              >
                Reset Answer
              </SecondaryButton>
              <SecondaryButton
                color={"rgba(63, 65, 209, 1)"}
                border="1px solid rgba(63, 65, 209, 1)"
                onClick={() => {
                  handleNext("next");
                  handleAuditLogFeedback("", "next");
                }}
                disabled={currentSrNo === questionLength}
              >
                Next
              </SecondaryButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <FeedbackCompletedModal />
      <ZoomModal img={questionsAndOptionsFeedback?.questionData?.question} />
    </>
  );
}
